export default __webpack_public_path__ + "static/media/img_pick_return.d5b09ff9.svg";